var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import FunnelAgeImageSrc from '@images/marketing/funnel/Funnel-Age-Page.jpg';
import { useProfileContext } from '@marketing/profile/ProfileContext';
import { ProfilePageLayout, ProfilePageMain } from '@marketing/profile/common/ProfilePageLayout';
import { useNavigate } from 'react-router';
var PetAgePage = function () {
    var navigate = useNavigate();
    var _a = useProfileContext(), currentPet = _a.currentPet, currentPetIndex = _a.currentPetIndex, profileBasePath = _a.profileBasePath;
    var handleClickPrevious = function () {
        navigate("".concat(profileBasePath, "/pet/").concat(currentPetIndex, "/breed"), { viewTransition: true });
    };
    var handleClickNext = function () {
        navigate("".concat(profileBasePath, "/pet/").concat(currentPetIndex, "/age"), { viewTransition: true });
    };
    return (_jsx(ProfilePageLayout, __assign({ handleClickNext: handleClickNext, handleClickPrevious: handleClickPrevious }, { children: _jsxs(ProfilePageMain, __assign({ heading: "Next up: Age", imageData: { src: FunnelAgeImageSrc, alt: 'Dog licking snout' } }, { children: ["Puppy, adult or sassy senior? Our tailored meals will keep ", currentPet.name, " in the prime of life."] })) })));
};
export default PetAgePage;
